module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAABJElEQVQ4T2NkoBJgpJI5DMPdoHnzljczMjLWkBNe////70lKiiwFh9H8+St6GRgYisg0qD8pKbIIbNCqVauYv3z5v46R8b8fKYb9/8+4iYeHMSgsLOwvPNbmz5/PwcDAuZeBgcGKSMOOMjB8d0lMTPwBUo8S/QsXLhT++5f9ECMjgxY+w/7/Z7jGyPjdOjEx8QNMHUY6mjlzoRwrK9tRRkZGGWyG/f///8nv37+s09PjHyHLY02Qs2cv02NhYTrAwMAgiGbYe2ZmBuu4uIjr6JbgTNlz5qy0Y2b+v4OBgYETquk7ExOTc3x82HFsLsWbRebPXxnw//+/tQwMjP8YGRlDExPDN+AKO4J5bf78Za7//zP/T0oK34MvAggaRGRSGIS5HwCGTFcTzUBJMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/basic/drop_down.png
// module id = TZUU
// module chunks = 2